import React, { FC } from 'react';
import { IconProps } from './index';

export const Laundry: FC<IconProps> = ({ color, size = 24 }) => {
  return <svg width={size} height={size} viewBox="0 0 20 20" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M14,3.2H6C4.5,3.2,3.2,4.5,3.2,6v8c0,1.5,1.2,2.8,2.8,2.8h8c1.5,0,2.8-1.2,2.8-2.8V6C16.8,4.5,15.5,3.2,14,3.2z M6,4.8h8c0.6,0,1.1,0.4,1.2,1H4.8C4.9,5.2,5.4,4.8,6,4.8z M15.2,14c0,0.7-0.6,1.2-1.2,1.2H6c-0.7,0-1.2-0.6-1.2-1.2V7.2h10.5V14z"/>
    <path d="M10,14.2c1.8,0,3.2-1.5,3.2-3.2S11.8,7.8,10,7.8S6.8,9.2,6.8,11S8.2,14.2,10,14.2z M10,9.2c1,0,1.8,0.8,1.8,1.8 S11,12.8,10,12.8S8.2,12,8.2,11S9,9.2,10,9.2z"/>
  </svg>;
};
